var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proce-payment-record"},[_c('GlobalInfoBar',{attrs:{"title":"异常付款单据重置记录","content":"留存订单重置记录"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('Form')],1),_c('Table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }